import { Dialog, DialogContent, DialogTitle } from "@uicomponents/ui/dialog";

import { AuthModalParams } from "@realtorSitesClient/store/modalSlice";
import { Box } from "@mui/material";
import { Authenticator } from "./auth/Authenticator";

interface AuthDialogProps {
  isOpen: boolean;
  onClose: () => void;
  dialogParams: AuthModalParams | null;
}

export function AuthDialog({ isOpen, onClose, dialogParams }: AuthDialogProps) {
  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogContent className="sm:max-w-[600px] p-0 overflow-hidden gap-0">
        <Box className="p-6 flex items-center justify-center border-b">
          <DialogTitle className="sr-only">Sign in or register</DialogTitle>
          <img
            src="../../Images/top-left-logo.webp"
            alt=""
            className="h-[72px] w-auto"
          />
        </Box>

        <div className="p-6">
          <Authenticator
            defaultTab={dialogParams?.defaultTab}
            defaultUsername={dialogParams?.defaultUsername}
            defaultPassword={dialogParams?.defaultPassword}
          />
          <div className="mt-6 text-center text-xs text-muted-foreground">
            By continuing, you agree to our Terms of Service and Privacy Policy.
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
